/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__, or convert again using --optional-chaining
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Helper methods for handling LinkedIn logins
namespace('Slzr', function(exports, top) {
  let jQuery;
  const $ = (jQuery = Slzr.jQuery);

  return (function() {
    const Cls = (exports.LinkedIn = class LinkedIn {
      static initClass() {
        this.login_url = null;
        this.logout_url = null;
  
        this.login = () => {
          return __guard__(typeof IN !== 'undefined' && IN !== null ? IN.User : undefined, x => x.authorize(() => exports.LinkedIn.loggedIn()));
        };
  
        this.logout = () => {
          __guard__(typeof IN !== 'undefined' && IN !== null ? IN.User : undefined, x => x.logout());
          return exports.LinkedIn.loggedOut();
        };
  
        this.loggedIn = () => {
          // Redirect to the login_url to finish handling linked in
          // console.log '[linkedin] logged in'
          return location.href = exports.LinkedIn.login_url;
        };
  
        this.loggedOut = () => {
          // Redirect to /auth/logout, to clean up the session
          // console.log '[linkedin] logged out'
          return location.href = exports.LinkedIn.logout_url;
        };
      }
    });
    Cls.initClass();
    return Cls;
  }());
});

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}